import * as React from 'react';
import './find-us.css';
import { Loader } from 'google-maps';

export function FindUs(): React.ReactElement {
  React.useEffect(() => {
    (async () => {
      const loader = new Loader('AIzaSyCuFHDLJF-WS8qwqJlw9kfgexlVQeB5Y9s', {});
      const google = await loader.load();

      (function maps() {
        let map;
        let mapStyle;
        let mapStyleObject;
        let mapLocation;
        let mapOptions;
        let mapMarker;
        let mapMarkerImage;
        let mapInfoWindow;

        function setMapStyle() {
          mapStyle = [
            {
              featureType: 'landscape',
              stylers: [
                {
                  saturation: -100,
                },
                {
                  lightness: 60,
                },
              ],
            },
            {
              featureType: 'road.local',
              stylers: [
                {
                  saturation: -100,
                },
                {
                  lightness: 40,
                },
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'transit',
              stylers: [
                {
                  saturation: -100,
                },
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'administrative.province',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'water',
              stylers: [
                {
                  visibility: 'on',
                },
                {
                  lightness: 30,
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#ef8c25',
                },
                {
                  lightness: 40,
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#b6c54c',
                },
                {
                  lightness: 40,
                },
                {
                  saturation: -40,
                },
              ],
            },
            {},
          ];

          mapStyleObject = new google.maps.StyledMapType(mapStyle, { name: 'Styled Map' });
        }

        function setMapLocation() {
          mapLocation = new google.maps.LatLng(54.352369, 18.638309);
        }

        function setMapOptions() {
          mapOptions = {
            zoom: 17.5,
            center: mapLocation,
            scrollwheel: false,
            draggable: true,
            mapTypeId: google.maps.MapTypeId.SATELLITE,
            mapTypeControl: true,
            zoomControl: true,
            zoomControlOptions: {
              style: google.maps.ZoomControlStyle.LARGE,
              position: google.maps.ControlPosition.RIGHT_TOP,
            },
          };
        }

        function setInfoWindow() {
          mapMarkerImage = {
            url: 'img/logo-46px.png',
            size: new google.maps.Size(46, 46),
          };

          mapMarker = new google.maps.Marker({
            position: mapLocation,
            map: map,
            title: 'Advocare',
          });

          mapInfoWindow = new google.maps.InfoWindow();
          mapInfoWindow.setOptions({
            content:
              "<div class='map-info-box'><strong>Advocare Kancelaria Adwokacka</strong><br/>ul. Strzelecka 7b, 80-803 Gdańsk</div>",
            position: mapLocation,
            pixelOffset: new google.maps.Size(-1, -40),
            alignTop: true,
          });
        }

        function initializeMap() {
          map = new google.maps.Map(
            document.getElementById('map-container') as HTMLElement,
            mapOptions,
          );
          map.mapTypes.set('map_style', mapStyleObject);
          // map.setMapTypeId('map_style');
        }

        function applyEventListeners() {
          google.maps.event.addListener(mapMarker, 'click', () => {
            mapInfoWindow.open(map);
          });
        }

        return (function initMaps() {
          setMapLocation();
          setMapStyle();
          setMapOptions();
          initializeMap();
          setInfoWindow();
          applyEventListeners();
          mapInfoWindow.open(map);
        })();
      })();
    })();
  }, []);

  return <div id="map-container" />;
}
